import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { Business } from '../types';
type UseBusinessOptions = {
  slugName?: string;
  lat?: number;
  lng?: number;
};
export const getBusiness = ({slugName, lat, lng}: UseBusinessOptions = {}): Promise<Business> => {
  return axios.get(lat && lng ? `/business/slug/${slugName}?lat=${lat}&lng=${lng}` : `/business/slug/${slugName}`, {
    params: {},
  });
};

type QueryFnType = typeof getBusiness;
export const useBusiness = ({slugName}: UseBusinessOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['business'],
    queryFn: () => getBusiness({slugName}),
  });
};



type UseOptions = {
  config?: MutationConfig<typeof getBusiness>;
};

export const useGetBussiness = ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBusiness,
  });
};

